import { render, staticRenderFns } from "./UnionsViewPage.vue?vue&type=template&id=18be65ca&"
import script from "./UnionsViewPage.vue?vue&type=script&lang=js&"
export * from "./UnionsViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports